//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    currentStep: {
      type: Number,
      default: 0,
    },
  },
  fetch() {
    this.step = this.currentStep
  },
  data() {
    return {
      step: 0,
    }
  },
  methods: {
    handleNext() {
      if (this.step === 2) {
        this.$router.push('/inicio')
      }
      this.step = this.step + 1
      this.$emit('change-step', this.step)
    },
    handlePrevious() {
      if (this.step === 0) {
        this.$router.push('/inicio')
      }
      this.step = this.step - 1
      this.$emit('change-step', this.step)
    },
  },
}
